<div class="results-container">
    @for (
        infoCardData of lookupCards;
        track $index;
        let i = $index;
        let last = $last
    ) {
        <molecule-info-card
            class="result-card text-truncate"
            size="sm"
            [avatars]="infoCardData.avatars"
            [primaryInfo]="infoCardData.primaryInfo"
            [tertiaryInfo]="infoCardData.tertiaryInfo"
        >
            @if (!disabled) {
                <button
                    tabindex="-1"
                    wdxStopPropagation
                    class="custom-actions"
                    wdxIconButton
                    [wdxButton]="WdxButtonStyle.None"
                    [wdxButtonSize]="WdxButtonSize.Sm"
                    (click)="deleteItem.emit(infoCardData)"
                >
                    <wdx-icon [icon]="UTILS_ICON_DELETE"></wdx-icon>
                </button>
            }
        </molecule-info-card>
        @if (!last) {
            <div class="divider-end divider--short"></div>
        }
    }
</div>
